import { useEffect } from "react";
import {
  Form,
  Button,
  FormGroup,
  Input,
  InputGroup,
  Label,
  FormFeedback,
} from "reactstrap";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Stack } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { useResetPasswordMutation } from "../../services/useAuth/useAuthMutation";

export function CompleteRegistration() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      password: "",
      password_confirmation: "",
      token: "",
    },
  });

  const { mutate: resetPasswordMutation } = useResetPasswordMutation(setError);
  const password = watch("password");

  const onSubmit = (data) => {
    resetPasswordMutation({
      token: data.token,
      password: data.password,
      password_confirmation: data.password_confirmation,
    });
  };

  useEffect(() => {
    // Extract token from URL query parameter
    const token = searchParams.get("token");

    if (token) {
      setValue("token", token);

      // Remove token from URL
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete("token");
      setSearchParams(newSearchParams, { replace: true });
    }
  }, [searchParams, setValue, setSearchParams]);

  return (
    <div className="login-card1 decorative-arabic-text-bg">
      <Form
        className="theme-form login-form pattern-card rounded-3 border border-1"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Stack gap={3}>
          <h4>{t("ADD_NEW_PASSWORD")}</h4>
          <h6>{t("ADD_NEW_PASSWORD_DESCRIPTION")}</h6>
        </Stack>

        <FormGroup>
          <Label className="required" for="password">
            {t("PASSWORD")}
          </Label>
          <InputGroup className="position-relative">
            <Controller
              name="password"
              control={control}
              rules={{
                required: t("PASSWORD_REQUIRED") || "Password is required",
                minLength: {
                  value: 8,
                  message:
                    t("PASSWORD_MIN_LENGTH") ||
                    "Password must be at least 8 characters",
                },
              }}
              render={({ field }) => (
                <Input
                  {...field}
                  type="password"
                  id="password"
                  invalid={!!errors.password}
                />
              )}
            />
          </InputGroup>
          {errors.password && (
            <FormFeedback className="d-block">
              {errors.password.message}
            </FormFeedback>
          )}
        </FormGroup>

        <FormGroup>
          <Label className="required" for="password_confirmation">
            {t("CONFIRM_PASSWORD")}
          </Label>
          <InputGroup className="position-relative">
            <Controller
              name="password_confirmation"
              control={control}
              rules={{
                required:
                  t("CONFIRM_PASSWORD_REQUIRED") ||
                  "Password confirmation is required",
                validate: (value) =>
                  value === password ||
                  t("PASSWORDS_DO_NOT_MATCH") ||
                  "Passwords do not match",
              }}
              render={({ field }) => (
                <Input
                  {...field}
                  type="password"
                  id="password_confirmation"
                  invalid={!!errors.password_confirmation}
                />
              )}
            />
          </InputGroup>
          {errors.password_confirmation && (
            <FormFeedback className="d-block">
              {errors.password_confirmation.message}
            </FormFeedback>
          )}
        </FormGroup>

        <FormGroup>
          <Button block color="dark" type="submit" size="lg">
            {t("CONFIRM")}
          </Button>
        </FormGroup>
      </Form>
    </div>
  );
}
